import { UserOutlined } from '@ant-design/icons';
import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import styled, { css } from 'styled-components';
import { useImmer } from 'use-immer';
import tableIcon from '../assets/table-icon.svg';
import appIcon from '../assets/app-icon.svg';
import {useAuth} from "../common/AuthProvider";

const CommonHeader = styled.div`
    height: 48px;
    width: 100%;
    background: white;
    box-shadow: inset 0px -1px 0px #DDDDDD;
    display: flex;
    box-sizing: border-box;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
`

const LeftContent = styled.div`
    flex: auto;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
`

const TableIconWrapper = styled.div`
    width: calc(16px + 32px + 16px);
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
`

const TableIcon = styled.img`
    width: 14px;
    height: 14px;
`

const Divider = styled.div`
    height: 32px;
    width: 1px;
    border-radius: 1px;
    background-color: #ddd;
`

const AppIcon = styled.img`
    margin-inline: 16px;
    height: 32px;
    width: 32px;
`

const HeaderTitle = styled.div`
    font-family: Arial, serif;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: rgba(11, 13, 14, 0.65);
`

const RightContent = styled.div`
    padding-inline: 24px;
    flex: 0 0 auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`

const UserInfo = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`

const AvatarIcon = styled(UserOutlined)`
    display: flex;
    justify-content: center;
    width: 24px;
    height: 24px;
    margin-right: 12px;
`

const UserDomainId = styled.div`
    font-family: Arial, serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    text-align: center;
    color: rgba(11, 13, 14, 0.6);
`

interface NonProdEnvironmentWarningProps {
    readonly show: boolean;
};

const NonProdEnvironmentWarning = styled.div<NonProdEnvironmentWarningProps>`
    ${(props) => !props.show && css`display: none;`}
    position: fixed;
    left: 50%;
    top: 0;
    color: red;
    font-size: 32px;
    line-height: 48px;
    font-weight: bold;
    transform: translate(-50%, 0);
`

const AppHeader: React.FC = () => {

    const [userName, setUserName] = useImmer('');
    const { user } = useAuth();
    const hostname = window.location.hostname;
    let nonProdEnvironmentTips
    if (hostname.includes('dev.')) {
        nonProdEnvironmentTips = '*** DEV testing environment ***'
    } else if (hostname.includes('uat.')) {
        nonProdEnvironmentTips = '*** UAT testing environment ***'
    } else {
        nonProdEnvironmentTips = ''
    }

    useEffect(() => {
        if (user?.username) {
            setUserName(user.username)
        }
    }, [user]);

    return (
        <>
            <CommonHeader>
                <LeftContent>
                    <TableIconWrapper>
                        <TableIcon src={tableIcon} alt='No Icon' />
                    </TableIconWrapper>
                    <Divider />
                    <AppIcon src={appIcon} alt='No Icon' />
                    <HeaderTitle>Rate of Exchange</HeaderTitle>
                </LeftContent>
                <RightContent>
                    <UserInfo>
                        <AvatarIcon />
                        <UserDomainId>{userName}</UserDomainId>
                    </UserInfo>
                </RightContent>
            </CommonHeader>
            {
                createPortal(
                    <NonProdEnvironmentWarning show={!!nonProdEnvironmentTips}>{nonProdEnvironmentTips}</NonProdEnvironmentWarning>,
                    document.body
                )
            }
        </>
    )
}

export default AppHeader
